import { ToastrComponents } from '../components/ToastrComponents';

$(document).ready(function() {
    const toastr_components = new ToastrComponents();

    toastr_components.executaToastrsIniciais();
    $('[data-toggle="tooltip"]').tooltip();
});